/** Persist the exact financial intent before transmission; ambiguous failures retain it. */
export async function prepareFinancialOperation(actor: string, path: string, payload: unknown) {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(JSON.stringify(payload)));
  const fingerprint = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
  const storageKey = `admin-financial-operation:${actor}:${path}:${fingerprint}`;
  const operationId = sessionStorage.getItem(storageKey) || crypto.randomUUID();
  sessionStorage.setItem(storageKey, operationId);
  return { storageKey, operationId };
}

export function isFinancialWrite(method: string | undefined, path: string) {
  return method?.toLowerCase() === 'post' && (path === '/add-credits' ||
    /^\/admin\/subscription-credit-batches\/[^/]+\/(create|adjust)$/.test(path));
}
